// Authenticated header used in requests
export const authHeader = () => {
  const token = localStorage.getItem('JWT');
  if (token) {
    return `Bearer ${token}`;
  }
  return {};
};
